import Repository from "./Repository";
import masterRepository from "./masters/masterRepository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const login = "/marcom/admin/login";
const createNewPassword = "/marcom/admin/createNewPassword";
const addUserAsAdmin = "/users/addAdmin";
const contactUs_Data = "/marcom/contactUs/get";

const getRoles = "/admin/roles/get";
const addRole = "/admin/roles/add";
const removeRole = "/admin/roles/remove";
const getAdmins = "/marcom/admin/getAdmins";
const deleteAdmins = "/marcom/admin/deleteAdmins";
const addAdmin = "/users/addAdmin";
const editAdmin = "/users/editAdmin";

const sendEMail = "/marcom/admin/sendEmail";
const sendOTP = "/marcom/admin/resetPasswordOTP";
const confirmOTP = "/marcom/admin/resetPassword";
export default {
  sendOTP(payload) {
    return Repository.post(`${sendOTP}`, payload);
  },
  confirmOTP(payload) {
    return Repository.post(`${confirmOTP}`, payload);
  },
  userLogin(payload) {
    return Repository.post(`${login}`, payload);
  },

  createNewPassword(payload) {
    // return payload.admin
    //   ? masterRepository.post(`${createNewPassword}`, payload)
    //   : Repository.post(`${createNewPassword}`, payload);
    return Repository.post(`${createNewPassword}`, payload);
  },
  contactUsData(payload) {
    return Repository.post(`${contactUs_Data}`, payload);
  },
  addUserAsAdmin(payload) {
    return Repository.post(`${addUserAsAdmin}`, payload);
  },

  editUserAsAdmin(payload) {
    return Repository.post(`${editAdmin}`, payload);
  },

  getRoles(payload) {
    return Repository.post(`${getRoles}`, payload);
  },

  addRole(payload) {
    return Repository.post(`${addRole}`, payload);
  },
  removeRole(payload) {
    return Repository.post(`${removeRole}`, payload);
  },

  getAdmins(payload) {
    return Repository.post(`${getAdmins}`, payload);
  },
  deleteAdmins(payload) {
    return Repository.post(`${deleteAdmins}`, payload);
  },

  addAdmin(payload) {
    return Repository.post(`${addAdmin}`, payload);
  },
  EmailSend(payload) {
    return Repository.post(`${sendEMail}`, payload);
  },
};
